export interface IFineConditionType {
    id: number,
    name: string
}

export enum FineConditionType {
    OneTime = 1,
    Repeat = 2
}